function PinIcon(props) {
  return (
    <svg id='PinIcon' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 10 16' {...props}>
      <g id='Raggruppa_74' data-name='Raggruppa 74' transform='translate(-3)'>
        <path
          id='Tracciato_70'
          data-name='Tracciato 70'
          d='M4.146.146A.5.5,0,0,1,4.5,0h7a.5.5,0,0,1,.5.5,2.086,2.086,0,0,1-.646,1.479,2.858,2.858,0,0,1-.354.3V6.708l.078.048a5.894,5.894,0,0,1,.751.555A3.024,3.024,0,0,1,13,9.5a.5.5,0,0,1-.5.5h-4v4.5c0,.276-.224,1.5-.5,1.5s-.5-1.224-.5-1.5V10h-4A.5.5,0,0,1,3,9.5,3.026,3.026,0,0,1,4.17,7.311a5.921,5.921,0,0,1,.83-.6V2.277a2.77,2.77,0,0,1-.354-.3A2.088,2.088,0,0,1,4,.5.5.5,0,0,1,4.146.146Zm1.58,1.408h0Zm0,0h0A.5.5,0,0,1,6,2V7a.5.5,0,0,1-.276.447h0l-.012.007-.054.03a4.922,4.922,0,0,0-.827.58A2.645,2.645,0,0,0,4.1,9H11.9a2.645,2.645,0,0,0-.725-.936,4.915,4.915,0,0,0-.881-.61l-.012-.006h0A.5.5,0,0,1,10,7V2a.5.5,0,0,1,.3-.458,1.775,1.775,0,0,0,.351-.271A1.353,1.353,0,0,0,10.86,1H5.14a1.382,1.382,0,0,0,.214.271A1.78,1.78,0,0,0,5.724,1.553Z'
        />
      </g>
    </svg>
  )
}

export default PinIcon
